import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import HomeIcon from "@material-ui/icons/Home";
import WeekscheduleIcon from "@material-ui/icons/Event";
import BookingsIcon from "@material-ui/icons/AccountCircle";
import Badge from "@material-ui/core/Badge";
import CoursesIcon from "../Images/CoursesIcon";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    borderTop: `1px solid ${theme.app.borderColor}`,
    display: "none",
    position: "fixed",
    bottom: 0,
    height: "4.375rem",
    "@media(max-width: 600px)": {
      display: "flex",
    },
    "& span": {
      fontSize: "14px",
      fontWeight: "500",
    },
  },
  unpaid: {
    backgroundColor: theme.app.dangerColor,
    color: "white",
  },
  paid: {
    backgroundColor: theme.app.infoColor,
    color: "white",
  },
  button: {
    color: theme.app.labelColor,
  },
}));

const BottomNav = (props) => {
  const { mybookings, location, history } = props;
  const { language, culture } = useSelector((state) => ({
    language: state.language,
  }));
  const classes = useStyles();
  const [value, setValue] = React.useState(location.pathname);
  useEffect(() => {
    setValue(location.pathname);
  }, [location]);

  function handleChange(event, newValue) {
    // setValue(newValue);
    history.push(newValue);
  }

  const confirmed =
    mybookings && mybookings.filter((b) => b.isConfirmed).length;
  const anyUnpaid =
    mybookings && mybookings.some((b) => !b.isPaid && b.isConfirmed);

  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      className={classes.root}
      showLabels
    >
      <BottomNavigationAction
        label={language.home}
        value="/"
        icon={<HomeIcon />}
        className={classes.button}
      />
      <BottomNavigationAction
        label={language.courses}
        value="/courses"
        icon={<CoursesIcon active={value === "/courses"} />}
        className={classes.button}
      />
      <BottomNavigationAction
        label={language.week_schedule}
        value="/week"
        icon={<WeekscheduleIcon />}
        className={classes.button}
      />
      <BottomNavigationAction
        label={language.bookings}
        value="/bookings"
        className={classes.button}
        icon={
          confirmed && value !== "/bookings" ? (
            <Badge
              badgeContent={confirmed}
              classes={{
                badge: anyUnpaid ? classes.unpaid : classes.paid,
              }}
            >
              <BookingsIcon className={classes.buttonIcon} />
            </Badge>
          ) : (
            <BookingsIcon className={classes.buttonIcon} />
          )
        }
      />
    </BottomNavigation>
  );
};

export default withRouter(BottomNav);
